/*
 * Copyright (c) 2021. World Wide Generation Ltd
 */

export enum AnalyticsEvents {
  AssuranceDataDownloaded = 'assurance_data_downloaded',
  UserInvited = 'user_invited',
  UserInvitationRevoked = 'user_invitation_revoked',
  UserInvitationClick = 'user_invitation_click',
  UserInvitationReject = 'user_invitation_reject',
  UserRegistered = 'user_registered',
  UserActivated = 'user_activated',
  UserLogin = 'user_login',
  CustomMetricGroupCreated = 'custom_metrics_group_created',
  CustomMetricCreated = 'custom_metrics_created',
  CustomMetricAdded = 'custom_metric_added',
  MaterialityCustomized = 'materiality_customized',
  VisibilityUpdated = 'visibility_updated',
  SurveyCreated = 'survey_created',
  SurveyShared = 'survey_shared',
  SurveyDeleted = 'survey_deleted',
  SurveyCompleted = 'survey_completed',
  SurveyAssuranceDatapointUpdated = 'survey_assurance_datapoint_updated',
  SurveyAssuranceCreated = 'survey_assurance_created',
  SurveyReject = 'survey_reject_button',
  SurveyVerify = 'survey_verify_button',
  SurveyConfirm = 'survey_confirm_button',
  SurveyConfirmVerify = 'survey_confirm_verify_button',
  SurveyMarkAsNA = 'survey_mark_as_na_button',
  SurveyMarkAsNR = 'survey_mark_as_nr_button',
  SurveyDelegationAdded = 'survey_delegation_added',
  SurveyDelegationRemoved = 'survey_delegation_removed',
  SurveyBulkAction = 'survey_bulk_action',
  SurveyScopeUpdated = 'survey_scope_updated',
  SurveyDataDownloaded = 'survey_data_downloaded',
  SurveyTemplateCreated = 'survey_template_created',
  SurveyTemplateUpdated = 'survey_template_updated',
  SurveyTemplateDuplicated = 'survey_template_duplicated',
  SurveyTemplateDeleted = 'survey_template_deleted',
  SurveyScopeDeleted = 'survey_scope_deleted',
  SupportInfo = 'support_info',
  SurveyDuplicate = 'survey_duplicate',
  OnboardingStep = 'onboarding_step',
  OnboardingCompleted = 'onboarding_completed',
  SDGGraphDownload = 'sdg_graph_download',
  SDGGraphLink = 'sdg_graph_link',
  SDGGraphEmbed = 'sdg_graph_embed',
  SurveyGroupView = 'survey_group_view',
  CheckoutSessionCompleted = 'checkout_session_completed',
  EmissionCalculatorView = 'emission_calculator_view',
  EmissionCalculatorExternalView = 'emission_calculator_external_view',
  IntegrationView = 'integration_view',
  IntegrationExternalView = 'integration_external_view',
}
